import { render, staticRenderFns } from "./OrderPrintView.vue?vue&type=template&id=88f45eae&"
import script from "./OrderPrintView.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrderPrintView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrderPrintView.vue?vue&type=style&index=0&id=88f45eae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports